import { z } from "zod";

const ONBOARDING_KEY = "dua-workspace:onboarding";
const locationSchema = z.object({
  source: z.enum(["automatic", "manual"]),
  latitude: z.number().min(-90).max(90),
  longitude: z.number().min(-180).max(180),
  accuracy: z.number().nonnegative().optional(),
  updatedAt: z.string()
});

const onboardingSchema = z.object({
  completed: z.boolean(),
  completedAt: z.string().optional(),
  showArabic: z.boolean().default(true),
  showTransliteration: z.boolean().default(false),
  language: z.string().default("en"),
  starterCollections: z.array(z.string()).default([]),
  location: locationSchema.optional()
});

export type OnboardingState = z.infer<typeof onboardingSchema>;

export const DEFAULT_ONBOARDING_STATE: OnboardingState = {
  completed: false,
  showArabic: true,
  showTransliteration: false,
  language: "en",
  starterCollections: []
};

export function readOnboardingState(): OnboardingState {
  try {
    const raw = localStorage.getItem(ONBOARDING_KEY);
    if (!raw) return DEFAULT_ONBOARDING_STATE;
    return onboardingSchema.parse(JSON.parse(raw));
  } catch {
    return DEFAULT_ONBOARDING_STATE;
  }
}

export function writeOnboardingState(state: OnboardingState): void {
  localStorage.setItem(ONBOARDING_KEY, JSON.stringify(onboardingSchema.parse(state)));
}

export function resetOnboarding(): void {
  localStorage.removeItem(ONBOARDING_KEY);
}

export function retainOnboardingCompletion(completedAt: string): void {
  writeOnboardingState({ ...DEFAULT_ONBOARDING_STATE, completed: true, completedAt });
}
